export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: d.getFullYear() === new Date().getFullYear() ? undefined : "numeric",
  });
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function pct(value: number | null | undefined, digits = 0): string {
  if (value === null || value === undefined) return "—";
  return `${value.toFixed(digits)}%`;
}

export function recordText(record: { wins: number; losses: number }): string {
  return `${record.wins}–${record.losses}`;
}

export const END_REASON_LABEL: Record<string, string> = {
  concede: "You conceded",
  opponent_concede: "Opponent conceded",
  prizes: "All prizes taken",
  other: "Game over",
  unknown: "Unknown",
};
